import React from "react";
import { useTranslation } from "react-i18next";
import { Container } from "@material-ui/core";

import VideoPlayer from "../components/VideoPlayer";
import Item from "../components/Item";
import Contactame from "../components/Contactame";

import Header from "../components/Header";
//import Video from "../assets/videos/talleres_2023.mp4";
import Footer from "../components/Footer";
import TalleresMetas2019 from "../assets/img/metas_2019.png";
import TalleresMetas2020 from "../assets/img/metas_2020.png";
import TalleresMetasDinero from "../assets/img/metas_y_dinero.png";
import TalleresMetasAmor from "../assets/img/metas_y_amor.png";
import TalleresNegatividadFavor from "../assets/img/negatividad_favor.png";
import TalleresSoltarPasado from "../assets/img/soltar_pasado.jpg";
import TalleresAlquimizarRealidad from "../assets/img/alquimizar_realidad.jpg";
import TalleresOrdenaInterior from "../assets/img/ordena_interior.jpg";
import TalleresProgramate from "../assets/img/programate.jpg";
import TalleresSeñales1 from "../assets/img/señales1.jpg";
import TalleresSeñales2 from "../assets/img/señales2.jpg";
import TalleresSeñales3 from "../assets/img/señales3.jpg";
import TalleresGenealogia from "../assets/img/genealogia.jpg";

export default function WorkshopsPage() {
  const { t } = useTranslation();
  return (
    <div className="container--grid">
      <Header />
      <Container className="MuiContainer-disableGutters">
        {/* <VideoPlayer url={Video} /> */}
        <Item title={t("talleres.title")} description={t("talleres.note")} />
        <Item title={t("talleres.important.title")} description={t("talleres.important.note")} />
        <Item
          title={t("talleres.basicos.title")}
          description={t("talleres.basicos.description")}
        />
        <Item
          title={t("talleres.avanzados.title")}
          description={t("talleres.avanzados.description")}
        />
      </Container>
      {/* <Contactame /> */}
      <Footer title="Natalia Barrera" description="Descripcion" />
    </div>
  );
}
